/** Renders `text` with the parts wrapped in `**` in bold, as in "Turn on **Remote Worker**". */
export function HighlightedText({ text }: { text: string }) {
  return text.split('**').map((part, index) =>
    index % 2 ? (
      <strong key={index} className="font-semibold text-foreground">
        {part}
      </strong>
    ) : (
      part
    )
  );
}
